import React, { useState, useEffect } from "react";
import { RouteComponentProps } from "react-router-dom";
import { CircularProgress, CardContent, CardHeader, AppBar, Tabs, Tab } from "@material-ui/core";

import { Grid, Card } from "@mui/material"; // to be able to use sx property
import { useTranslation } from "react-i18next";

import httpClient from "../../../lib/httpClient";
import { EmergencyEventDescription } from "./EmergencyEventDescription";
import { saveUserMonitorData } from "../../util/userUtils";
import { EmergencyEventDetailsMap } from "./EmergencyEventDetailsMap";
import { EmergencyEventAoiList } from "./EmergencyEventAoiList";
import { EmergencyPolicies } from "./EmergencyPolicies";
import { EmergencyClaims } from "./EmergencyClaims";
import { EmergencyMunicipalities } from "./EmergencyMunicipalities";
import { MapSliderWithDescription } from "./mapSlider/MapSliderWithDescription";

export const EmergencyEventDetails = (props: RouteComponentProps<RouteComponentArgs>) => {
  const eventId = props.match.params.id;
  const { t } = useTranslation();

  const [event, setEvent] = useState<TerraShieldEvent>({} as TerraShieldEvent);
  const [selectedAoiList, setSelectedAoiList] = useState<TerraShieldEventAoi[]>([]);
  const [isEventFetching, setIsEventFetching] = useState(false);
  const [requestedTabIdx, setRequestedTabIdx] = useState(0);

  const [iniatialAoiList, setIniatialAoiList] = useState<TerraShieldEventAoi[]>([]);
  const [selectedPolicyList, setSelectedPolicyList] = useState<EmergencyPolicy[]>([]);

  useEffect(() => {
    const getEventData = async () => {
      setIsEventFetching(true);
      saveUserMonitorData("emergencyEventShow", eventId);

      const eventResult = await httpClient().get(`/terrashield/event/${eventId}`);
      const aoiListSelected = eventResult.data.aois.map((aoi: any) => ({ ...aoi, selected: true }));

      // the polygons should be all visible when the user first lands on the page
      setIniatialAoiList(aoiListSelected);
      setSelectedAoiList(aoiListSelected);
      setEvent(eventResult.data);
    };

    getEventData();
    setIsEventFetching(false);
  }, [eventId]);

  const handleTabChange = (event: any, newValue: number) => {
    setRequestedTabIdx(newValue);
  };

  return (
    <Grid container spacing={1} style={{ marginTop: 15 }}>
      <Grid item xs={8} sm={10} md={4} sx={{ height: "70vh" }}>
        <Card sx={{ height: "100%" }}>
          <CardHeader title={t("emergencyMonitoring.eventDescription")} />

          {isEventFetching ? (
            <Grid container justifyContent="center">
              <CircularProgress />
            </Grid>
          ) : (
            <CardContent style={{ paddingTop: "0" }}>
              <EmergencyEventDescription event={event} />
            </CardContent>
          )}
        </Card>
      </Grid>

      <Grid item xs={12} sm={12} md={8} sx={{ height: "70vh" }}>
        {Object.keys(event).length !== 0 ? (
          <EmergencyEventDetailsMap
            emergencyEvent={event}
            selectedAoiList={selectedAoiList}
            selectedPolicyList={selectedPolicyList}
          ></EmergencyEventDetailsMap>
        ) : (
          <Grid container justifyContent="center">
            <CircularProgress />
          </Grid>
        )}
      </Grid>

      <Grid item xs={12} sm={12}>
        {Object.keys(event).length !== 0 ? (
          <EmergencyEventAoiList
            eventId={eventId}
            aoiList={iniatialAoiList}
            selectAoiList={setSelectedAoiList}
          />
        ) : (
          <Grid container justifyContent="center">
            <CircularProgress />
          </Grid>
        )}
      </Grid>

      <Grid item xs={12} sm={12}>
        <AppBar position="static" color="default" elevation={0}>
          <Tabs
            value={requestedTabIdx}
            textColor="primary"
            indicatorColor="primary"
            onChange={handleTabChange}
          >
            <Tab label={t("menu.newpolicies")} />
            <Tab label={t("menu.newclaims")} />
            <Tab label={t("menu.municipalities")} />
          </Tabs>
        </AppBar>

        {requestedTabIdx === 0 && (
          <EmergencyPolicies
            activationCode={eventId}
            setSelectedPolicyList={setSelectedPolicyList}
            selectedPolicyList={selectedPolicyList}
          />
        )}

        {requestedTabIdx === 1 && <EmergencyClaims activationCode={eventId} />}

        {requestedTabIdx === 2 && <EmergencyMunicipalities activationCode={eventId} />}
      </Grid>

      <Grid item xs={12} sm={12}>
        <MapSliderWithDescription event={event} aoiList={iniatialAoiList}></MapSliderWithDescription>
      </Grid>
    </Grid>
  );
};
